module.exports = __webpack_public_path__ + "static/jones-63e8fb46e6bf5ece203f53e14f1163a4.png";